/* 
 * 接口统一集成模块
 */

// system
import * as test from './api/system/test'
import * as user from './api/system/user'

// 默认全部导出
export default {
	
	// system
	test,
	user,
}